export default class Tracking {
    constructor() {
        this.pageView();
    }
    pageView() {
        // Triggers every pageview event
        window.dataLayer.push({ event: 'page_view', data: {} });
        this.registerDatalayerConstants();
    }
    registerDatalayerConstants() {
        const dataLayerConstants = window.dataLayerConstants || {
            vanMosselAccountId: '',
            vanMosselAccountEmail: '',
            vanMosselAccountTelefoon: '',
            applicatieOmgeving: ''
        };
        dataLayerConstants.vanMosselAccountId = '';
        dataLayerConstants.vanMosselAccountEmail = '';
        dataLayerConstants.vanMosselAccountTelefoon = '';
        const prodHostnames = [
            'www.maxus-motors.nl'
        ];
        const accHostnames = [
            'www.maxus-nl-preview.nobearshosting.nl'
        ];
        const { hostname } = new URL(window.location.href);
        let applicatieOmgeving = 'tst';
        if (prodHostnames.includes(hostname)) {
            applicatieOmgeving = 'prod';
        }
        else if (accHostnames.includes(hostname)) {
            applicatieOmgeving = 'acc';
        }
        dataLayerConstants.applicatieOmgeving = applicatieOmgeving;
    }
}
